import { render } from "./HeroiconsSolidCube.vue?vue&type=template&id=e8260aac"
const script = {}

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCube.vue"]])

export default __exports__